
import styles from './ZonesScreen.module.css';
import helpers from './helpers.js';
import {useState, useContext, useCallback, useEffect, useRef} from 'react';
import { UserContext } from './UserContext.js';
import { GoogleMap, useJsApiLoader, DrawingManager, Polygon, Marker, InfoWindow } from '@react-google-maps/api';

import Nav from "./components/Nav.js";
import ScreenHeader from "./components/ScreenHeader.js";
import Module from "./components/Module.js";
import TextInput from "./components/TextInput.js";
import Button from "./components/Button.js";
import FAQ from "./components/support/FAQ.js";

import { GOOGLE_MAPS_LOADER_OPTIONS, IS_GOOGLE_MAPS_KEY_MISSING } from './config/googleMaps.js';
import iconZoneMarker from './assets/images/iconZoneMarker.png';
import iconZoneMarkerUnselected from './assets/images/iconZoneMarkerUnselected.png';

// Grayscale marker icons
import iconMarkerBbbGrey from './assets/images/iconMarkerBbbGrey.png';
import iconMarkerWheatGrey from './assets/images/iconMarkerWheatGrey.png';
import iconMarkerCowGrey from './assets/images/iconMarkerCowGrey.png';
import iconMarkerHousingGrey from './assets/images/iconMarkerHousingGrey.png';

import ZoneDetails from './components/zones/ZoneDetails.js';
import PlanDetails from './components/zones/PlanDetails.js';

import MapLayerPanel from './components/mapLayers/MapLayerPanel';
import { getZoneLandData } from './components/mapLayers/lib/zoneLandData';

// Helper function to get grayscale marker icon
const getGrayscaleMarkerIcon = (markerType) => {
  const grayscaleIconMap = {
    'bbb': iconMarkerBbbGrey,
    'wheat': iconMarkerWheatGrey,
    'cow': iconMarkerCowGrey,
    'dairy': iconMarkerCowGrey,
    'housing': iconMarkerHousingGrey,
  };
  return grayscaleIconMap[markerType] || iconMarkerBbbGrey;
};

const mapContainerStyle = {
  marginLeft: "0.5rem",
  width: '100%',
  height: '100%',
  boxShadow: "0.2rem 0.2rem 0.5rem rgba(0, 0, 0, 0.1), 0px 4px 0.6rem rgba(0, 0, 0, 0.12)",
  borderRadius: "1.3rem"
};


//54.713801, -2.749613
const center = {
  lat: 54.713801,
  lng: -2.749613
};

const zonesArray = [
  {
    id: "",
    status: "delivered",
    deliveryDate: "",
    pincharBags: "",
    pelletcharBags: "",
    weight: "",
    volume: ""
  }
]


// A zone has a usable centre only when center_point.coordinates is exactly
// [lng, lat] with both entries finite numbers. The old `?.coordinates?.length
// === 2` guard counted entries but not their type, so [null, 51.5] or
// ["51.5", "-0.1"] passed and then reached the @react-google-maps/api Marker
// position contract, which wants two numbers. Same class of defect as the
// BBB-521 ring-position fix, one layer up. Used for both the markers and the
// fitBounds calls below, since a NaN coordinate corrupts the bounds too.
const hasUsableCenter = (zone) => {
  const c = zone?.center_point?.coordinates;
  return Array.isArray(c) && c.length === 2 &&
    Number.isFinite(c[0]) && Number.isFinite(c[1]);
};


function ZonesScreen(props) {
  // const {user, setUser} = useContext(UserContext);
  // const [selectedFilter, setSelectedFilter] = useState("all");
  // const [zones, setZones] = useState(zonesArray);



  // const renderZones = () => {
  //   let filteredZones = [];
  //   if(selectedFilter === "all"){
  //     filteredZones = zones;
  //   }else {
  //     filteredZones = zones.filter(function (zone) {
  //       return zone.status === selectedFilter 
  //     }
  //   );
  // }

  // const renderStatus = (status) => {
  //   switch(status){
  //     case "delivered":
  //       return <td className={styles.statusDelivered}><span className={styles.statusIcon}>check-circle</span>Delivered</td>
  //     case "upcoming":
  //       return <td className={styles.statusUpcoming}><span className={styles.statusIcon}>arrow-circle-right</span>Upcoming</td>
  //     case "cancelled":
  //       return <td className={styles.statusCancelled}><span className={styles.statusIcon}>times-circle</span>Cancelled</td>
  //     default:
  //         return <td>N/A</td>
  //   }

  // }
 

//   return(
//     <>
//       {filteredZones.map(zone => {
//         return(
//           <tr className={styles.tableRow}>
//             <td className={styles.dataBold}>#{zone.id}</td>
//             {renderStatus(zone.status)}
//             <td>{zone.deliveryDate}</td>
//             <td><span className={styles.dataBold}>{zone.pincharBags} </span>Bags</td>
//             <td><span className={styles.dataBold}>{zone.pelletcharBags}</span> Bags</td>
//             <td><span className={styles.dataBold}>{zone.weight} </span>tons</td>
//             <td><span className={styles.dataBold}>{zone.volume}</span> m<span className={styles.exp}>3</span></td>
//           </tr>
//         ) 
//       })
//     }
//     </>
//   )
// }
//   return (
//     <div className={helpers.clx("mainBlackContainer", "mainBlackContainerLoggedIn")}>
//       <Nav goToScreen={props.goToScreen} currentScreen={"zones"}/>
//       <div className={helpers.clx("mainWhiteContainer", "mainWhiteContainerLoggedIn")}>
//         <div className={helpers.clx("mainWhiteContainerContent", props.screenTransitioning ? "mainWhiteContainerContentHidden" : "")}>
//           <ScreenHeader name={"Zones"} content={"Browse through your biochar zones. Don’t hesitate to contact us if you have any questions!"}/>
//           <div className={"contentGrid"}>
//             <Module spanColumn={24} spanRow={5} height={"100%"}>
//               <div className={styles.headerRow}>
//                 <div onClick={() => setSelectedFilter("all")} className={helpers.clx(styles.headerFilter, selectedFilter === "all" ? styles.headerFilterSelected : "")}>
//                   All
//                 </div>
//                 <div onClick={() => setSelectedFilter("upcoming")} className={helpers.clx(styles.headerFilter, selectedFilter === "upcoming" ? styles.headerFilterSelected : "")}>
//                   Upcoming
//                 </div>
//                 <div onClick={() => setSelectedFilter("delivered")} className={helpers.clx(styles.headerFilter, selectedFilter === "delivered" ? styles.headerFilterSelected : "")}>
//                   Delivered
//                 </div>
//                 <div onClick={() => setSelectedFilter("cancelled")} className={helpers.clx(styles.headerFilter, selectedFilter === "cancelled" ? styles.headerFilterSelected : "")}>
//                   Cancelled
//                 </div>
//               </div>
//               <table className={styles.zoneTable}>
//                 <tr className={styles.zoneHeaderRow}>
//                   <th>Zone ID</th>
//                   <th>Status</th>
//                   <th>Delivery Date</th>
//                   <th>Pinchar</th>
//                   <th>Pelletchar</th>
//                   <th>Weight</th>
//                   <th>Volume</th>
//                 </tr>
//                 {renderZones()}
//               </table>

//             </Module>
//           </div>
//         </div>
//       </div>
//     </div>
//   );


/*

{ isLoaded ? 
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={8}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        <DrawingManager
          onPolygonComplete={onPolygonComplete}
          options={{
            drawingControl: true,
            drawingControlOptions: {
              position: window.google.maps.ControlPosition.TOP_CENTER,
              drawingModes: ['polygon'],
            },
            polygonOptions: {
              editable: true,
              draggable: true,
            },
          }}
        />
      </GoogleMap>
     : null
    }

*/
const {user, setUser} = useContext(UserContext);

const { isLoaded, loadError } = useJsApiLoader(GOOGLE_MAPS_LOADER_OPTIONS);
const [map, setMap] = useState(null);
const [zones, setZones] = useState([]);
const [selectedZoneIndex, setSelectedZoneIndex] = useState(null);

const [allPolygons, setAllPolygons] = useState([]);
const [bounds, setBounds] = useState(null);
const [plans, setPlans] = useState([]);
const [searchInput, setSearchInput] = useState("");

const [selectedPlan, setSelectedPlan] = useState("all");
// How many map data layers are toggled on (reported up by MapLayerPanel). When any
// layer is active the zone polygons drop their fill to outline-only so they stop
// hiding the layer rendered beneath them.
const [activeLayerCount, setActiveLayerCount] = useState(0);
const hasActiveLayers = activeLayerCount > 0;
// The attribution lines owed for the layers currently drawn, derived inside
// MapLayerPanel (where layerStates lives) and reported up so ZoneDetails can
// render them under Land characteristics. See components/mapLayers/MapCredits.js.
const [mapCredits, setMapCredits] = useState([]);

const polygonRefs = useRef([]);


//FUNCTION HERE



const fetchPlans = async () => {
  try {
    const res = await fetch(`${user.backEndURL}/plans/${user.details.id}`, {
      headers: {
        Authorization: `Bearer ${user.token}`
      }
    });
    const response = await res.json();
    if (response.success) {
      setPlans(response.data.plans);
      setSelectedPlan("all");
    }
  } catch (err) {
    console.error("Failed to fetch plans", err);
  }
};  


const fetchZones = async () => {
  console.log()
  setSelectedZoneIndex(null)
  const request = {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.token,
    }
  };
  let response = await fetch(user.backEndURL + "/zones/" + user.details.id, request);
  let jsonResponse = await response.json();
  if (jsonResponse.success) {
    console.log(jsonResponse.data.zones)
    setZones(jsonResponse.data.zones)
    if (map && jsonResponse.data.zones.length > 0) {
      // 🔹 Fit map to all zones on load
      const bounds = new window.google.maps.LatLngBounds();
      jsonResponse.data.zones.forEach(zone => {
        if (hasUsableCenter(zone)) {
          bounds.extend({
            lat: zone.center_point.coordinates[1],
            lng: zone.center_point.coordinates[0]
          });
        }
        if (zone.polygon_shape?.coordinates?.length > 0) {
          zone.polygon_shape.coordinates[0].forEach(coord => {
            bounds.extend({ lat: coord[1], lng: coord[0] });
          });
        }
      });
      setBounds(bounds)
      map.fitBounds(bounds);
      fetchPlans();
    }
  } else {
    console.log("Fetch Subscription Failed...")
  }
  
}

useEffect(() => {
  console.log("Fetching Zones")
  if (!user || !user.details?.id) return; // Ensure user is available before fetching

  

  if (map) {
    fetchZones();
  }

  

},[map, user.details?.id]) 

const onLoad = useCallback((mapInstance) => {
  setMap(mapInstance);
}, []);

const onUnmount = useCallback((mapInstance) => {
  setMap(null);
}, []);


// 🔹 Adjust map when a zone is selected
const handleZoneSelection = (index) => {
  setSelectedZoneIndex(index);
  const selectedZone = zones[index];

  if (selectedZone) {
    if (selectedZone.polygon_shape?.coordinates?.length > 0) {
      // 🔹 Zoom to polygon bounds
      const bounds = new window.google.maps.LatLngBounds();
      selectedZone.polygon_shape.coordinates[0].forEach(coord => {
        bounds.extend({ lat: coord[1], lng: coord[0] });
      });
      map.fitBounds(bounds);
    } else if (hasUsableCenter(selectedZone)) {
      // 🔹 Zoom to marker position with an appropriate field-level zoom
      map.setCenter({
        lat: selectedZone.center_point.coordinates[1],
        lng: selectedZone.center_point.coordinates[0]
      });
      map.setZoom(18); // Adjust field zoom level
    }
  }
};

// 🔹 Handle zone click - switch to "All Zones" if clicking zone not in current plan
const handleZoneClick = (index) => {
  const zone = zones[index];

  // Warm the land-data cache the moment a zone is selected, so the fetch runs
  // behind the select-to-panel transition instead of starting only once
  // ZoneLandCharacteristics mounts. Only in the "all" view, because that is the
  // only path that opens ZoneDetails (and therefore the characteristics panel);
  // in a plan view the click opens PlanDetails, which does not consume this, so
  // prefetching there would be a request with no visible consumer. Where there
  // IS a consumer, it owns the loading and error state and re-requests the same
  // cached promise, so this warm call is purely latency hiding: it changes only
  // when the request starts, never what is shown. Gated on a real boundary,
  // since a marker-only zone has no land data to fetch.
  if (selectedPlan === "all" && zone?.polygon_shape?.coordinates?.length) {
    // The panel is the single owner of real error handling; this prefetch only
    // primes the shared cache, so a rejection here is intentionally not surfaced.
    getZoneLandData(zone).catch(() => {});
  }

  if (selectedPlan === "all") {
    // Normal behavior - just select the zone
    handleZoneSelection(index);
  } else {
    // Check if zone is in current plan
    const isInPlan = isZoneInSelectedPlan(zone);
    
    if (!isInPlan) {
      // Zone not in plan, switch to "All Zones" first
      setSelectedPlan("all");
      // Fit map to all zones
      if (map && bounds) {
        map.fitBounds(bounds);
      }
    }
    // Select the zone (will work after state updates)
    handleZoneSelection(index);
  }
};

const renderPlanNav = () => {
  const planOptions = plans.map((plan, index) => ({
    label: plan.plan_name || `See Plan ${index + 1}`,
    index
  }));
  console.log(planOptions)
  
  return(
    <div className={styles.navContainer}>
      
      <div className={styles.plansContainer}>
        <div className={helpers.clx(styles.planOption, selectedPlan === "all" ? styles.planOptionSelected : "")} onClick={() => setSelectedPlan("all")}>
          All Zones
        </div>
        {planOptions.map((option) => (
          <div className={helpers.clx(styles.planOption, selectedPlan === option.index.toString() ? styles.planOptionSelected : "")} onClick={() => selectPlan(option.index.toString())}>    
            {option.label}
          </div>
        ))}
    
        
      </div>
      <div className={helpers.clx(styles.planOption, styles.planOptionNew, zones.length < 1 ? styles.planOptionNewDisabled : "")} onClick={() => props.goToScreen("/new-plan", {zones: zones})}>
          Add New Plan +
        </div>
    </div>
  )
}

const getZoneColor = (zone) => {
  if (!zone.targeted_rate || !zone.biocharApplied) return "#1B1B1B"; // coalLight
  const applied = parseFloat(zone.biocharApplied);
  const target = parseFloat(zone.targeted_rate);
  const ratio = Math.min(applied / target, 1);

  // Interpolate from coalLight to leafGreen (#B0E000)
  const coalRGB = [27, 27, 27];
  const leafRGB = [176, 224, 0];

  const rgb = coalRGB.map((start, i) => {
    return Math.round(start + (leafRGB[i] - start) * ratio);
  });

  return `rgb(${rgb.join(",")})`;
};


const fitMapToPlanZones = (plan) => {
  if (!map || !plan?.targeted_zones?.length) return;

  const bounds = new window.google.maps.LatLngBounds();

  plan.targeted_zones.forEach((tz) => {
    const zone = tz._zone || tz; // tz._zone is populated, or just the zone object itself

    if (hasUsableCenter(zone)) {
      bounds.extend({
        lat: zone.center_point.coordinates[1],
        lng: zone.center_point.coordinates[0]
      });
    }

    if (zone.polygon_shape?.coordinates?.length > 0) {
      zone.polygon_shape.coordinates[0].forEach((coord) => {
        bounds.extend({ lat: coord[1], lng: coord[0] });
      });
    }
  });

  map.fitBounds(bounds);
};


const selectPlan = (planIndex) => {
  setSelectedZoneIndex(null);
  setSelectedPlan(planIndex);

  const plan = plans[planIndex];
  if (plan) {
    fitMapToPlanZones(plan);
  }
};


const getZoneRatioColor = (zone) => {
  
  const applied = parseFloat(zone.biocharApplied || 0);
  const target = parseFloat(zone.targeted_rate || 0);
  console.log(!applied || !target)
  if (!applied || !target) return "rgb(255,165,0)"; // fallback: coalLight

  const ratio = Math.min(applied / target, 1);

  const from = [255, 165, 0];  // orange (low applied)
  const to = [176, 224, 0];    // leaf green

  const blend = from.map((start, i) =>
    Math.round(start + (to[i] - start) * ratio)
  );
  console.log(`rgb(${blend.join(",")})`)
  return `rgb(${blend.join(",")})`;
};

const isZoneInSelectedPlan = (zone) => {
  if (selectedPlan === "all") return true;

  const plan = plans[selectedPlan];
  if (!plan?.targeted_zones) return false;

  return plan.targeted_zones.some(z => {
    const planZoneId = z._zone?._id || z._zone; // works if it's populated or just an ID
    return String(planZoneId) === String(zone._id);
  });
};

const calculateTotalBiocharApplied = (zone) => {
  if (!zone.applications || zone.applications.length === 0) {
    return null; // Return null if no applications
  }
  
  // Sum all application weights (in kg) and convert to tons
  const totalKg = zone.applications.reduce((sum, app) => {
    return sum + (parseFloat(app.weight) || 0);
  }, 0);
  
  const totalTons = totalKg / 1000;
  
  // Format to 2 decimal places
  return totalTons.toFixed(2);
};

const zoomToAddress = async (address) => {
  if (!window.google || !map) return;

  const geocoder = new window.google.maps.Geocoder();
  
  geocoder.geocode({ address }, (results, status) => {
    if (status === "OK" && results[0]) {
      const location = results[0].geometry.location;
      map.setCenter(location);
      map.setZoom(15); // Or zoom level you want
    } else {
      console.error("Geocode failed:", status);
    }
  });
};

return(
    <div className={helpers.clx("mainWhiteContainerContent", props.screenTransitioning ? "mainWhiteContainerContentHidden" : "")}>
      <ScreenHeader iconName="FaMapMarkedAlt" name={"Biochar Plan"} content={"Add, edit, and delete the zones you own, and create a biochar application plan from these. These are used to map biochar application to your land."}/>
      
      <div className={helpers.clx("contentGrid", styles.contentGrid)}>
        <div className={styles.newZoneButtonContainer}>
          <Button name={"Add New Zone +"} onPress={() => props.goToScreen("/new-zone", {zones: zones})} color={"Coal"}/>

        </div>
        

          <div className={styles.mapContainer}>
            {renderPlanNav()}
            <div className={styles.mapTabsWrapper}>

            {(loadError || IS_GOOGLE_MAPS_KEY_MISSING) ? (
              <div style={{ ...mapContainerStyle, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '1rem' }}>
                The map couldn’t be loaded. Please refresh the page or try again shortly.
              </div>
            ) : (
              <>
            {isLoaded && (

              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                center={center}
                zoom={8}
                onLoad={onLoad}
                onUnmount={onUnmount}
                options={{
                  disableDefaultUI: true,
                  draggable: true,
                  zoomControl: true,
                  scrollwheel: true,
                  disableDoubleClickZoom: true,
                  draggableCursor: "crosshair",
                  // mapTypeId now controlled by MapLayerPanel's satellite/street toggle (BBB-424 prototype)
                  keyboardShortcuts: false, // disables keyboard shortcuts AND hides the button
                  fullscreenControl: false, // optional: hides fullscreen button
                  mapTypeControl: false,    // optional: hides map type buttons
                }}
              >
                {/* <div className={styles.searchContainer}>
                  <TextInput
                  placeholder="Enter postcode or address..."
                  value={searchInput}
                  onChange={setSearchInput}
                  name=""
                />
                  <div className={styles.searchButtonContainer}>
                    <Button name="Go" onPress={() => zoomToAddress(searchInput)} color="Coal" />
                  </div>
                </div> */}
                {/* 🔹 Loop through zones and render polygons or markers */}
                {zones.map((zone, index) => {
                  const isSelected = index === selectedZoneIndex; // 🔹 Check if this zone is selected
                  const fillColor = getZoneColor(zone);

                  if (zone.polygon_shape?.coordinates?.length > 0) {
                    // 🔹 Convert GeoJSON format to Google Maps Polygon format
                    const polygonPaths = zone.polygon_shape.coordinates[0].map(coord => ({
                      lat: coord[1],  // GeoJSON stores [lng, lat], Google Maps uses {lat, lng}
                      lng: coord[0]
                    }));

                    return (
                      <>
                        <Polygon
                          key={zone._id}
                          paths={polygonPaths}
                          options={{
                            fillColor:
                              selectedPlan === "all"
                                ? (isSelected ? "#B0E000" : "#fff")
                                : isZoneInSelectedPlan(zone)
                                  // ? getZoneRatioColor(zone)
                                  ? "#B0E000"
                                  : "#E0E0E0",
                            fillOpacity:
                              hasActiveLayers
                                // A data layer is on — outline only so it shows through.
                                ? 0
                                : selectedPlan === "all"
                                  ? (isSelected ? 0.8 : 0.14)
                                  : isZoneInSelectedPlan(zone)
                                    ? 0.6
                                    : 0.3,
                            strokeColor:
                              selectedPlan === "all"
                                ? (isSelected ? "#B0E000" : "#fff")
                                : isZoneInSelectedPlan(zone)
                                  // ? getZoneRatioColor(zone)
                                  ? "#B0E000"
                                  : "#BBBBBB",
                            strokeWeight: 2,
                            clickable: true,
                            editable: false,
                            draggable: false
                          }}
                          label={{
                            text: zone.zone_name, // ✅ Set the zone name as the label
                            color: "white", // ✅ Text color
                            fontSize: "12px",
                            fontWeight: "bold",
                            className: helpers.clx(styles.polygonLabel,styles.polygonLabelSelected ) // ✅ Optional custom CSS class for styling
                          }}
                          onClick={() => handleZoneClick(index)} // 🔹 Clicking selects this zone
                        />
                        {hasUsableCenter(zone) && (
                        <Marker
                          position={{
                            lat: zone.center_point.coordinates[1],
                            lng: zone.center_point.coordinates[0],
                          }}
                          options={{
                            zIndex: isSelected ? 1000 : 1, // ✅ Push selected marker in front
                          }}
                          icon={{
                            url: "", // ✅ Empty URL to hide the default marker icon
                            scaledSize: new window.google.maps.Size(1, 1), // ✅ Makes the marker invisible,
                            labelOrigin: new window.google.maps.Point(1, 15) // ✅ Moves label BELOW the icon

                          }}
                          label={{
                            text: zone.zone_name,
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "bold",
                            className: helpers.clx(styles.polygonLabel, (isSelected || (selectedPlan !== "all" && isZoneInSelectedPlan(zone))) ? styles.polygonLabelSelected : "" ) // Green label for selected/plan zones
                          }}
                          onClick={() => handleZoneClick(index)}
                        />
                        )}
                      </>
                    );
                  } else if (hasUsableCenter(zone)) {
                    return (
                      <>
                        <Marker
                          key={zone._id}
                          position={{
                            lat: zone.center_point.coordinates[1], 
                            lng: zone.center_point.coordinates[0],
                          }}
                          options={{
                            fillOpacity: isSelected ? 0.6 : 0.14, // 🔹 Highlight selected zone
                            zIndex: (isSelected || (selectedPlan !== "all" && isZoneInSelectedPlan(zone))) ? 1000 : 1, // ✅ Push selected/plan marker in front
                            opacity: (isSelected || (selectedPlan !== "all" && isZoneInSelectedPlan(zone))) ? 1 : 0.8 // Full opacity for selected/plan zones
                          }}
                          icon={{
                            url: (isSelected || (selectedPlan !== "all" && isZoneInSelectedPlan(zone)))
                              ? helpers.getMarkerIcon(zone.marker_type)
                              : getGrayscaleMarkerIcon(zone.marker_type),
                            scaledSize: (isSelected || (selectedPlan !== "all" && isZoneInSelectedPlan(zone)))
                              ? new window.google.maps.Size(80, 80)  // ✅ Bigger for selected/plan zones
                              : new window.google.maps.Size(65, 65),    // ✅ Normal size for unselected
                            anchor: (isSelected || (selectedPlan !== "all" && isZoneInSelectedPlan(zone)))
                              ? new window.google.maps.Point(40, 50)   // ✅ Adjust anchor for bigger size
                              : new window.google.maps.Point(40, 70),  // ✅ Normal anchor
                            labelOrigin: (isSelected || (selectedPlan !== "all" && isZoneInSelectedPlan(zone)))
                              ? new window.google.maps.Point(40, 90)   // ✅ Adjust label position for bigger size
                              : new window.google.maps.Point(32.5, 80)   // ✅ Normal label position
                            
                          }}
                          label={{
                            text: zone.zone_name, // ✅ Set the zone name as the label
                            color: "white", // ✅ Text color
                            fontSize: "12px",
                            fontWeight: "bold",
                            className: helpers.clx(styles.polygonLabel, (isSelected || (selectedPlan !== "all" && isZoneInSelectedPlan(zone))) ? styles.polygonLabelSelected : "" ) // Green label for selected/plan zones
                          }}
                          // className={isSelected ? "selectedZoneMarker" : "zoneMarker"} // 🔹 Add CSS class
                          onClick={() => handleZoneClick(index)} // 🔹 Clicking selects this marker
                          className={styles.zoneMarker}
                        
                        > 
                      

                        </Marker>
                        {/* <InfoWindow
                            position={{
                              lat: zone.center_point.coordinates[1],
                              lng: zone.center_point.coordinates[0]
                            }}
                            // onCloseClick={() => setSelectedMarker(null)}
                          >
                            <div className={styles.infoWindow}>
                              {zone.zone_name}
                            </div>
                          </InfoWindow> */}
                      </>
                      
                    );
                  }
                  return null;
                })}
              
              </GoogleMap>
            )}
            {isLoaded && (
              <MapLayerPanel
                map={map}
                onActiveLayersChange={setActiveLayerCount}
                onCreditsChange={setMapCredits}
                zones={zones}
                selectedZoneIndex={selectedZoneIndex}
              />
            )}
              </>
            )}
            </div>
          </div>
        
        <div className={styles.zonesListContainer}>
          <div className={styles.zonesListHeaderRow}>
            <div>Zone Name</div>
            <div>Biochar Applied</div>
          </div>
          {zones.length > 0 ? zones.map((zone, i) => {
            const totalBiochar = calculateTotalBiocharApplied(zone);
            return(
              <div className={helpers.clx(
                styles.zoneRow,
                (i === selectedZoneIndex || (selectedPlan !== "all" && isZoneInSelectedPlan(zone)))
                  ? styles.zoneRowSelected
                  : ""
              )}  onClick={() => handleZoneClick(i)}>
                <div className={styles.zoneName}>
                  <span className={styles.zoneTypeIcon}>
                    {zone.zone_type === "livestock" ? "home" : "seedling"}
                  </span>
                  {zone.zone_name}
                </div>
                <div className={helpers.clx(
                  styles.zoneBiocharApplied,
                  totalBiochar !== null ? styles.zoneBiocharAppliedActive : ""
                )} style={{
                  color:
                    totalBiochar !== null 
                      ? "var(--leaf)"
                      : selectedPlan === "all"
                        ? "var(--grey)"
                        : isZoneInSelectedPlan(zone)
                          ? getZoneRatioColor(zone)
                          : "#999"
                }}>
                  {totalBiochar !== null ? `${totalBiochar} t` : "n/a"}
                </div>
              </div>
            )
          }) :
          <div className={helpers.clx(styles.zoneRow)}  >
            <div className={styles.placeholderZoneName}>-</div>
            <div className={styles.placeholderZoneName}>-</div>
          </div>
           }
        </div>
        {/* <Module name={"User Details"} spanColumn={10} spanRow={2} height={"100%"}>
          <div/>
        </Module> */}
      </div>
      
        {
          allPolygons.map((polygon, index) => {
            console.log(polygon)
            return(
              <div>{polygon.coordinates.map((coordinates) => {
                return (
                  <div>
                    x: {coordinates.lat}, y: {coordinates.lng}
                  </div>
                )
              })}
              </div>
            );
          })
        }
        {selectedPlan === "all" 
          ? <ZoneDetails selectedZone={zones[selectedZoneIndex]} reloadZones={fetchZones} mapCredits={mapCredits}/> 
          : <><PlanDetails 
            selectedPlan={plans[selectedPlan]}
            zones={zones}
            reloadZones={fetchZones} 
         /></>
        }

    </div>
  )

}

export default ZonesScreen;
